import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UniversityService} from '../../../shared/services/university.service';
import {PcbMappingService} from '../../../shared/services/pcb-mapping.service';

@Component({
    selector: 'app-university-pcb-mapping',
    templateUrl: './university-pcb-mapping.component.html',
    styleUrls: ['./university-pcb-mapping.component.scss']
})
export class UniversityPcbMappingComponent implements OnInit {
    showSearch = false;
    id: any;
    universityId: any;
    data: any;
    updatePasswordForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    pcbmapping = [];
    university: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private activatedRoute: ActivatedRoute,
                private pcbMappingService: PcbMappingService,
                private universityService: UniversityService) {
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-university-pcb-mapping').toggleOpen();
    }

    goBack(): void {
        this.router.navigateByUrl('universities');
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'program_id': [''],
            'course_id': [''],
            'branch_id': [''],
        });
        this.get();
        this.getUniversityDetail();

    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
            }
        });
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.pcbmapping = [];
        this.pcbMappingService.getByAdmin(this.universityId, params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.pcbmapping = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.pcbmapping = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'program_id': (this.searchForm.value && this.searchForm.value.program_id) ? this.searchForm.value.program_id : '',
            'course_id': (this.searchForm.value && this.searchForm.value.course_id) ? this.searchForm.value.course_id : '',
            'branch_id': (this.searchForm.value && this.searchForm.value.branch_id) ? this.searchForm.value.branch_id : '',
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            program_id: (this.searchForm && this.searchForm.value && this.searchForm.value.program_id) ? this.searchForm.value.program_id : '',
            course_id: (this.searchForm && this.searchForm.value && this.searchForm.value.course_id) ? this.searchForm.value.course_id : '',
            branch_id: (this.searchForm && this.searchForm.value && this.searchForm.value.branch_id) ? this.searchForm.value.branch_id : '',
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.pcbMappingService.updateStatusByAdmin(this.universityId, data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    courseCurriculum(data: any) {
        this.router.navigateByUrl('course-curriculum/' + data.id);
    }
}
